import FlexPayPromoContainer from './FlexPayPromoContainer';

export default FlexPayPromoContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/FlexPayPromo/index.js